import PageTitle from "../components/PageTitle";

export default function RegularMenuPage() {
  return (
    <main className="admin-page flex flex-column gap-5">
      <PageTitle eyebrow="Regular Menu" title="Regular Menu Management">
        Regular menu controls use the same menu and location-item API foundations as weekly menus.
      </PageTitle>
    </main>
  );
}